// Group-size buckets for the Statistic Highlights dashboard.
//
// Every possible group size lands in exactly one bucket (singletons fold into
// the smallest bucket; the 13-15 band closes the gap the office's original
// 2 / 3-4 / 5-8 / 9-12 / 16+ list left open). Records with no usable group size
// (0 / missing) are collected under a separate "Unknown" bucket so they're
// visible but never silently dropped or mis-attributed.

export const GROUP_SIZE_BUCKETS = [
	{ key: "1-2", label: "1-2", min: 1, max: 2 },
	{ key: "3-4", label: "3-4", min: 3, max: 4 },
	{ key: "5-8", label: "5-8", min: 5, max: 8 },
	{ key: "9-12", label: "9-12", min: 9, max: 12 },
	{ key: "13-15", label: "13-15", min: 13, max: 15 },
	{ key: "16+", label: "16+", min: 16, max: Infinity },
]

export const UNKNOWN_BUCKET = { key: "unknown", label: "Unknown size", min: null, max: null }

// Resolve a numeric group size to its bucket key. Anything <= 0 / non-numeric
// is treated as unknown.
export const bucketKeyForSize = (size) => {
	const value = Number(size)
	if (!Number.isFinite(value) || value <= 0) return UNKNOWN_BUCKET.key

	const match = GROUP_SIZE_BUCKETS.find((bucket) => value >= bucket.min && value <= bucket.max)
	return match ? match.key : UNKNOWN_BUCKET.key
}

// Group a list of records (enquiries or bookings) by their group_size bucket.
// Returns a map of bucketKey -> array of records.
export const groupByBucket = (records = []) => {
	const grouped = {}
	;[...GROUP_SIZE_BUCKETS, UNKNOWN_BUCKET].forEach((bucket) => {
		grouped[bucket.key] = []
	})

	records.forEach((record) => {
		const key = bucketKeyForSize(record.group_size)
		grouped[key].push(record)
	})

	return grouped
}
